export default class Accordion {
    constructor(container) {
        this.container = container;
        this.items = [];
        this.itemSelector = null;
        this.resetClass = 'reset';
        this.oneOption = false;

        this.selectors = {
            header: '.header',
            content: '.content',
        };

        this.loadSettings();
    }

    init() {
        if (this.itemSelector !== null) {
            Array.from(this.container.querySelectorAll(this.itemSelector)).forEach(item => this.items.push(item));
        } else {
            Array.from(this.container.children).forEach(item => this.items.push(item));
        }

        // Filter items for valid accordeon items
        this.items = this.items.filter(item => item.hasAttribute('aria-expanded'));

        this.items.forEach(item => {
            const content = item.querySelector(this.selectors.content);
            if (item.getAttribute('aria-expanded') == 'true') {
                // content.style.height = `${content.scrollHeight}px`;
            } else {
                content.style.height = 0;
            }
        });

        // Timeout to check again, in case CSS loads slower
        setTimeout(() => {
            this.items.forEach(item => {
                const content = item.querySelector(this.selectors.content);
                if (item.getAttribute('aria-expanded') == 'true') {
                    content.style.height = `${content.scrollHeight}px`;
                }
            });
        }, 100);

        this.setEventListeners();

        // Once listeners are set, close all items
        this.items.forEach(item => {
            if (!item.hasAttribute('aria-expanded')) {
                item.setAttribute('aria-expanded', false);
                // Make all clickables inactive
                item.querySelectorAll('.content a, .content button').forEach(clickable => {
                    clickable.setAttribute('tabindex', '-1');
                });
            }
        });
    }

    setEventListeners() {
        this.items.forEach(item => {
            /** @type HTMLElement */
            const header = item.querySelector(this.selectors.header);
            const content = item.querySelector(this.selectors.content);
            header.addEventListener('click', this.toggleItem.bind(this, item));

            let closeButton;
            if (closeButton = content.querySelector('a.close')) {
                closeButton.addEventListener('click', this.toggleItem.bind(this, item));
            }

            header.setAttribute('tabindex', '0');
            header.addEventListener('keydown', e => {
                switch (e.key.toLowerCase()) {
                    case ' ':
                    case 'enter':
                        this.toggleItem(item);
                        break;
                    case 'escape':
                    case 'esc':
                        this.inactive(item);
                        break;
                }
            }, true);

            ['webkittransitionend', 'transitionend'].forEach(event => content.addEventListener(event, () => {
                this.transitionEnd(item);
            }));
        });
    }

    /**
     * 
     * @param {HTMLElement} item 
     */
    toggleItem(item) {
        if (item.getAttribute('aria-expanded') == 'true') {
            this.inactive(item);
        } else {
            this.active(item);
        }
    }

    active(item) {
        const content = item.querySelector(this.selectors.content);

        // First, lock its current css-calculated height
        content.style.height = `${content.clientHeight}px`; // Should be 0 for closed items anyway
        content.offsetHeight; // Merely reading this property is enough to trigger a repaint
        content.style.height = `${content.scrollHeight}px`; // Set it to the innerscroll's height, which should be all of its contents

        item.setAttribute('aria-expanded', 'true');
        // Make all clickables active
        content.querySelectorAll('a, button').forEach(clickable => {
            clickable.setAttribute('tabindex', '0');
        });

        if (this.oneOption) {
            this.items.forEach(otherItem => {
                if (otherItem != item) {
                    this.inactive(otherItem);
                }
            });
        }

        // If accordion item is an FAQ item, send GTM event
        if (item.hasAttribute('data-faqitemid')) {
            // Find FAQ question
            const question = item.querySelector('h3').innerText || item.querySelector('[itemprop="name"]').innerText;
            
            // Try to find matching category 
            let category = undefined;
            if (item.closest('#faqBlock')) {
                const categoryEl = item.closest('#faqBlock');
                category = categoryEl.querySelector('h2').innerText || categoryEl.querySelector('[itemprop="name"]').innerText || undefined;
            }

            if (question) {
                app.GTM.faqSelect(question, category);
            }
        }
    }

    inactive(item) {
        const content = item.querySelector(this.selectors.content);

        // First, lock its current css-calculated height
        content.style.height = `${content.clientHeight}px`; // Set it to the content's height, which should be all of its contents
        content.offsetHeight; // Merely reading this property is enough to trigger a repaint
        content.style.height = 0; // Set it to 0, so it animated as well

        item.setAttribute('aria-expanded', 'false');
        // Make all clickables inactive
        content.querySelectorAll('a, button').forEach(clickable => {
            clickable.setAttribute('tabindex', '-1');
        });
    }

    transitionEnd(item) {
        const content = item.querySelector(this.selectors.content);
        content.style.height = null; // Only reset the manually calculated height

        // reset rellax
        if (app.parallaxController && app.parallaxController.scrollScenes.length) {
            app.parallaxController.scrollScenes.forEach(scene => scene.refresh());
        }
    }

    loadSettings() {
        if (this.container.dataset.oneOption && this.container.dataset.oneOption == 'true') {
            this.oneOption = true;
        }

        if (this.container.dataset.itemSelector) {
            this.itemSelector = this.container.dataset.itemSelector;
        }
    }
}